



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { ProductInfoListMap, ProductCfg } from '@/types/newPersion'
import { comdify2 } from '@/utils/validate'
import FormItem from '@/components/formItem/index.vue'
@Component({
  components: {
    FormItem
  }
})
export default class ProdutInfoForm extends Vue {
  @Prop() productInfo!: ProductInfoListMap;
  @Prop() productCfg!: ProductCfg;
  comdify2 = comdify2
}
